@if (visible() && currentStep()) {
  <div class="guided-tour" role="dialog" aria-modal="true" [attr.aria-label]="currentStep()!.title">
    @if (targetRect(); as rect) {
      <div class="guided-tour__spotlight" [ngStyle]="spotlightStyle()"></div>

      <div class="guided-tour__card" [ngStyle]="cardStyle()">
        <div class="guided-tour__progress" aria-hidden="true">
          @for (step of steps(); track step.target; let index = $index) {
            <span
              class="guided-tour__dot"
              [class.guided-tour__dot--active]="index === currentStepIndex()"
              [class.guided-tour__dot--done]="index < currentStepIndex()">
            </span>
          }
        </div>

        <h3 class="guided-tour__title">{{ currentStep()!.title }}</h3>
        <p class="guided-tour__description">{{ currentStep()!.description }}</p>

        <div class="guided-tour__footer">
          <div class="guided-tour__actions">
            @if (!isFirstStep()) {
              <p-button label="Back" [outlined]="true" severity="secondary" size="small" (onClick)="previous()"></p-button>
            }
            @if (isLastStep()) {
              <p-button label="Finish" icon="pi pi-check" size="small" (onClick)="finish()"></p-button>
            } @else {
              <p-button label="Next" icon="pi pi-arrow-right" iconPos="right" size="small" (onClick)="next()"></p-button>
            }
          </div>
          <div class="guided-tour__dismiss">
            <button type="button" class="guided-tour__skip" (click)="skipForNow()">Skip for now</button>
            <span class="guided-tour__dismiss-sep" aria-hidden="true">·</span>
            <button type="button" class="guided-tour__dont-show" (click)="dontShowAgain()">Don't show again</button>
          </div>
        </div>
      </div>
    } @else {
      <div class="guided-tour__spotlight" style="top: 50%; left: 50%; width: 0; height: 0"></div>
      <div class="guided-tour__missing">
        <h3 class="guided-tour__title">{{ currentStep()!.title }}</h3>
        <p class="guided-tour__description">{{ currentStep()!.description }}</p>
        <div class="guided-tour__footer">
          <div class="guided-tour__actions">
            <p-button label="Next" size="small" (onClick)="next()"></p-button>
          </div>
          <div class="guided-tour__dismiss">
            <button type="button" class="guided-tour__skip" (click)="skipForNow()">Skip for now</button>
            <span class="guided-tour__dismiss-sep" aria-hidden="true">·</span>
            <button type="button" class="guided-tour__dont-show" (click)="dontShowAgain()">Don't show again</button>
          </div>
        </div>
      </div>
    }
  </div>
}
